import { Theme } from '@mui/material'

import { OverridedAlert } from '#/styles/Overrides/Alert'
import { OverridedAppBar } from '#/styles/Overrides/AppBar'
import { OverridedAutocomplete } from '#/styles/Overrides/Autocomplete'
import { OverridedButton } from '#/styles/Overrides/Button'
import { OverridedChip } from '#/styles/Overrides/Chip'
import { OverridedDatePicker } from '#/styles/Overrides/DatePicker'
import { OverridedDialog } from '#/styles/Overrides/Dialog'
import { OverridedDivider } from '#/styles/Overrides/Divider'
import { OverridedFab } from '#/styles/Overrides/Fab'
import { OverridedForm } from '#/styles/Overrides/Form'
import { OverridedIconButton } from '#/styles/Overrides/IconButton'
import { OverridedInput } from '#/styles/Overrides/Input'
import { OverridedLink } from '#/styles/Overrides/Link'
import { OverridedList } from '#/styles/Overrides/List'
import { OverridedPopover } from '#/styles/Overrides/Popover'
import { OverridedRadio } from '#/styles/Overrides/Radio'
import { OverridedSnackbar } from '#/styles/Overrides/Snackbar'
import { OverridedSvgIcon } from '#/styles/Overrides/SvgIcon'
import { OverridedTable } from '#/styles/Overrides/Table'
import { OverridedTabs } from '#/styles/Overrides/Tabs'
import { OverridedTooltip } from '#/styles/Overrides/Tooltip'

export default function componentsOverrides(theme: Theme) {
  return {
    ...OverridedAlert(theme),
    ...OverridedAppBar(),
    ...OverridedAutocomplete(),
    ...OverridedButton(theme),
    ...OverridedChip(theme),
    ...OverridedDatePicker(),
    ...OverridedDialog(),
    ...OverridedDivider(),
    ...OverridedFab(),
    ...OverridedForm(),
    ...OverridedIconButton(),
    ...OverridedInput(theme),
    ...OverridedLink(),
    ...OverridedList(),
    ...OverridedPopover(),
    ...OverridedRadio(),
    ...OverridedSnackbar(),
    ...OverridedSvgIcon(),
    ...OverridedTable(),
    ...OverridedTabs(),
    ...OverridedTooltip(),
  }
}
